import { useState } from "react";
import { ZoomIn, Play, X } from "lucide-react";

function DisplayMedia({ src, isImg, description }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="rounded-xl border border-forest/20 overflow-hidden shadow-md max-w-xl mx-auto">
        <div className="relative m-1 rounded-lg overflow-hidden">
          {isImg ? (
            <img
              src={src}
              alt="Fighn media"
              onClick={() => setOpen(true)}
              className="w-full h-auto rounded-lg cursor-pointer"
            />
          ) : (
            <video
              src={src}
              controls
              onClick={() => setOpen(true)}
              className="w-full h-auto rounded-lg cursor-pointer"
            >
              Your browser does not support the video tag.
            </video>
          )}
          <button
            aria-label={isImg ? "Zoom" : "Play"}
            onClick={() => setOpen(true)}
            className="absolute top-2 right-2 bg-ink/50 hover:bg-ink/70 text-canvas rounded-full p-1.5 transition-colors"
          >
            {isImg ? <ZoomIn className="w-4 h-4" /> : <Play className="w-4 h-4" />}
          </button>
        </div>
        {description && (
          <div className="p-4">
            <p className="text-sm text-ink/65">{description}</p>
          </div>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-ink/70" onClick={() => setOpen(false)} />
          <div className="relative bg-canvas rounded-xl p-4 max-w-2xl w-full">
            <button
              aria-label="Close"
              onClick={() => setOpen(false)}
              className="absolute -top-3 -right-3 bg-forest text-canvas rounded-full p-1.5"
            >
              <X className="w-4 h-4" />
            </button>
            {isImg ? (
              <img src={src} alt="Fighn media" className="w-full h-auto rounded-lg" />
            ) : (
              <video src={src} controls className="w-full h-auto rounded-lg">
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default DisplayMedia;